import { FC, ReactNode } from "react";
import { Text } from "@foris/avocado-suite";
import styles from "../../i18nCatalog.module.scss";

interface StatListProps {
  items: { label: string; value: ReactNode }[];
}

const StatList: FC<StatListProps> = ({ items }) => (
  <div className={styles.i18nCatalog_stats}>
    {items.map(({ label, value }) => (
      <Text className={styles.i18nCatalog_stat} key={label} type="sm">
        {value} {label}
      </Text>
    ))}
  </div>
);

export default StatList;
